import { render } from "./NewClass.vue?vue&type=template&id=d2bbdcd0"
import script from "./NewClass.vue?vue&type=script&lang=js"
export * from "./NewClass.vue?vue&type=script&lang=js"

import "./NewClass.vue?vue&type=style&index=0&id=d2bbdcd0&lang=css"

import exportComponent from "C:\\chuning\\cn-page\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__